import CreateAccountPage from '../CreateAccount'

function LoginPage() {
  return <CreateAccountPage isLogin />
}

export default LoginPage
